import {
  CLOSE_NOTIFICATION,
  COMPANY_INTERESTED_FAILURE,
  NO_ACTIVE_CAMPAIGNS
} from '../constants';

export const closeNotification = () => {
  return (dispatch, getState) => {
    dispatch({ type: CLOSE_NOTIFICATION, payload: {} });
  };
};

export const showAlreadyMatchedNotification = () => {
  return (dispatch, getState) => {
    dispatch({
      type: COMPANY_INTERESTED_FAILURE,
      payload: {}
    });
  };
};

export const showNoActiveCampaignsNotification = () => {
  return (dispatch, getState) => {
    dispatch({
      type: NO_ACTIVE_CAMPAIGNS,
      payload: {}
    });
  };
};

export const resetNotifications = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    const user = firebase.auth().currentUser;
    firestore
      .collection('notifications')
      .where('read', '==', false)
      .where('userId', '==', user.uid)
      .get()
      .then(notificationSnapshot => {
        if (notificationSnapshot.docs.length) {
          notificationSnapshot.docs.map(notificationDoc => {
            notificationDoc.ref
              .update({
                read: true
              })
              .then(() => {})
              .catch(err => {});
          });
        }
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/notificationsActions.js